import React, { useState } from "react";
import { Box, List, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import HomeIcon from "../../../src/assets/home_icon.svg";
import HomeIconActive from "../../../src/assets/home_icon_active.svg";
import MedicineIcon from "../../../src/assets/medicine_icon.svg";
import MedicineIconActive from "../../../src/assets/medicine_icon_active.svg";
import TreatmentTemplate from "../../../src/assets/treatment_template_icon.svg";
import TreatmentTemplateActive from "../../../src/assets/treatment_template_icon_active.svg";
import DosageIcon from "../../../src/assets/dosage_icon.svg";
import DosageIconActive from "../../../src/assets/dosage_icon_active.svg";
import TestShortCode from "../../../src/assets/test_short_code.svg";
import TestShortCodeActive from "../../../src/assets/test_short_code_active.svg";
import Diagnosis from "../../../src/assets/diagnosis.svg";
import DiagnosisActive from "../../../src/assets/diagnosis_active.svg";
import SpecialInstruction from "../../../src/assets/special_instruction.svg";
import SpecialInstructionActive from "../../../src/assets/special_instruction_active.svg";
import MedicineRemark from "../../../src/assets/medicine_remark.svg";
import MedicineRemarkActive from "../../../src/assets/medicine_remark_active.svg";
import FollowUp from "../../../src/assets/follow_up.svg";
import FollowUpActive from "../../../src/assets/follow_up_active.svg";

const Sidebar = ({ active, setActive }) => {
    const [hovered, setHovered] = useState(null);
    const menuItems = [
        { label: "Home", icon: HomeIcon, activeIcon: HomeIconActive, },
        { label: "Medicine List", icon: MedicineIcon, activeIcon: MedicineIconActive, },
        { label: "Treatment Templates", icon: TreatmentTemplate, activeIcon: TreatmentTemplateActive, },
        { label: "Dosage List", icon: DosageIcon, activeIcon: DosageIconActive, },
        { label: "Test Shortcodes", icon: TestShortCode, activeIcon: TestShortCodeActive, },
        { label: "Diagnosis", icon: Diagnosis, activeIcon: DiagnosisActive, },
        { label: "Special Instructions", icon: SpecialInstruction, activeIcon: SpecialInstructionActive, },
        { label: "Medicine Remarks", icon: MedicineRemark, activeIcon: MedicineRemarkActive, },
        { label: "Followup Lists", icon: FollowUp, activeIcon: FollowUpActive, },
    ];

    return (
        <Box
            sx={{
                width: "90px",
                height: "100%",
                backgroundColor: "neutral.white",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                py: 2,
                zIndex: 888,
            }}
        >
            <List sx={{ width: "100%" }}>
                {menuItems.map((item) => {
                    const isActive = active === item.label;
                    const isHovered = hovered === item.label;

                    return (
                        <ListItemButton
                            key={item.label}
                            onClick={() => setActive(item.label)}
                            onMouseEnter={() => setHovered(item.label)}
                            onMouseLeave={() => setHovered(null)}
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                gap: "6px",
                                py: 1.5,
                                mx: 1,
                                mb: 0.5,
                                borderRadius: "12px",
                                backgroundColor: isActive || isHovered ? "neutral.blueShadeBg" : "transparent",
                                color: isActive || isHovered ? "#0097B2" : "#A4A4A4",
                                transition: "all 0.3s ease",
                            }}
                        >
                            <ListItemIcon
                                sx={{
                                    minWidth: 0,
                                    justifyContent: "center",
                                    display: "flex",
                                }}
                            >
                                <img
                                    src={isActive || isHovered ? item.activeIcon : item.icon}
                                    alt={item.label}
                                    style={{ width: 24, height: 24 }}
                                />
                            </ListItemIcon>

                            <ListItemText
                                primary={item.label}
                                primaryTypographyProps={{
                                    fontFamily: 'Lato',
                                    textAlign: "center",
                                    fontSize: "10px",
                                    fontWeight: isActive ? 600 : 400,
                                }}
                            />
                        </ListItemButton>
                    );
                })}
            </List>
        </Box>
    );
};

export default Sidebar;
